import React from 'react';
import PropTypes from 'prop-types';
import VerticalLabelList from '../../../../label/VerticalLabelList';
import FieldSet from '../../../../fieldset/FieldSet';

const NcDmvDrivewayPermits = ({ selectedDrivewayPermit, }) => {
  const formatMoney = (money) => {
    if (typeof money === 'string') return parseFloat(money).toFixed(2);
    return `${parseFloat(money.amount).toFixed(2)} ${money.currencyCode}`;
  };

  const formatDateTime = (dateString) => {
    if (dateString === undefined || dateString === null) return '';
    return `${new Date(dateString)}`;
  };

  return (
    <>
      <FieldSet title="Driveway Permit">
        <VerticalLabelList items={VerticalLabelList.toList({
          Id: selectedDrivewayPermit.id,
          'Customer ID': selectedDrivewayPermit.customerId,
          'Permit Number': selectedDrivewayPermit.externalAccountId,
          'Original Bill Balance': formatMoney(selectedDrivewayPermit.originalBillBalance),
          'Client Reconciled Timestamp': selectedDrivewayPermit.clientReconciledTimestamp,
        })}
        />
      </FieldSet>

      <FieldSet title="Transaction">
        <VerticalLabelList items={VerticalLabelList.toList({
          Id: selectedDrivewayPermit.id,
          'Payment Transaction ID': selectedDrivewayPermit.paymentTransactionId,
          'Payment Transaction Line Item ID': selectedDrivewayPermit.paymentTransactionLineItemId,
          'Payment Amount': formatMoney(selectedDrivewayPermit.paymentAmount),
          'Payment Date': formatDateTime(selectedDrivewayPermit.paymentDate),
        })}
        />
      </FieldSet>
    </>
  );
};

export default NcDmvDrivewayPermits;

NcDmvDrivewayPermits.propTypes = {
  selectedDrivewayPermit: PropTypes.instanceOf(Object).isRequired,
};
